import React from "react";
import { makeIconDef } from "./makeIconDef";
export var DropdownArrowIconDef = {
    'dropdown-arrow': makeIconDef('dropdown-arrow', {
        regular: function () { return React.createElement("path", { d: "M3 7.5L12 16.5L21 7.5", stroke: "currentColor", strokeWidth: "1", strokeLinecap: "round" }); },
        filled: function () { return React.createElement("path", { d: "M3 7.5L12 16.5L21 7.5", stroke: "currentColor", strokeWidth: "e", strokeLinecap: "round" }); },
    })
};
